import { ISummaryTableDataNode } from 'components/common/SummaryTable/SummaryTable.properties';

const schema: ISummaryTableDataNode[] = [
    {
        objectName: 'CreditNotesSummary',
        isLoading: 'CreditNotesLoading',
        title: 'Credit note details',
        children: [
            {
                label: 'Customer',
                fieldNames: [
                    'CustomerIdDisplay',
                    'CustomerIdDisplayLabel',
                ],
                valueRenderer: {
                    hyperLink: {
                        link: false,
                        menu: true
                    },
                    api: {
                        api: '/customermaintenance/lookup/action',
                        name: 'CustomerId',
                        params: {
                            queryFields: {
                                CustomerId: 'CustomerId',
                                SearchText: ''
                            }
                        }
                    }
                }
            },
            {
                label: 'Customer P/Order',
                fieldNames: [
                    'CustomerPurchaseOrder'
                ],
            },
            {
                label: 'Invoice',
                fieldNames: [
                    'Invoice',
                ],
                valueRenderer: {
                    hyperLink: {
                        link: false,
                        menu: true
                    },
                    api: {
                        api: '/salesInvoiceEnquiry/lookup/action',
                        name: 'salesInvoiceEnquiry',
                        params: {
                            queryFields: {
                                InvoiceNumber: 'Invoice',
                                SalesEntity: 'Entity',
                                SearchText: ''
                            }
                        }
                    }
                }
            },
            {
                label: 'Credit reason',
                fieldNames: [
                    'CreditReason',
                    'CreditReasonLabel',
                ],
            },
            {
                label: 'Entity',
                fieldNames: [
                    'EntityDisplay',
                    'EntityDisplayLabel',
                ],
            },
            {
                label: 'Warehouse',
                fieldNames: [
                    'WarehouseDisplay',
                    'WarehouseDisplayLabel',
                ],
            },
            {
                label: 'Period',
                fieldNames: [
                    'PeriodDisplay'
                ],
            },
            {
                label: 'Date',
                fieldNames: [
                    'Date'
                ],
            }
        ]
    },
    {
        objectName: 'CreditNotesSummary',
        isLoading: 'CreditNotesLoading',
        title: 'Totals',
        children: [
            {
                label: 'Restocking Charge',
                fieldNames: [
                    'RestockingChargeDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 2,
                }
            },
            {
                label: 'Tax',
                fieldNames: [
                    'TaxDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 2
                }
            },
            {
                label: 'Invoice Total',
                fieldNames: [
                    'InvoiceTotalDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    emphasize: true,
                    floatingPoints: 2
                }
            },
        ]
    }
];

export default schema;
